// Le guide interactif (D-091), branché sur l'app : appelé par app.ts après chaque page.
//   * le moteur des visites (reprise d'une visite en cours, fin, carte de fin de la démo) ;
//   * le « ? » de l'en-tête (Sur cet écran) ;
//   * la démo : accueil avec le choix de la visite, bouton « Visite guidée » ;
//   * les « Montre-moi » de toute l'app (data-tour="…"), hors des feuilles qui ferment d'abord.
import { guideEnv, pagePainted, startTour, stopTour } from './engine';
import { demoAfterRender, demoEndCard, isDemoSession } from './demo';
import { addScreenHelp } from './screen-help';
import { forgetState } from './first-steps';
import { guideMark } from '../lib/guide';
import type { Ctx } from '../ui/context';

let wired = false;

export function guideAfterRender(view: HTMLElement, c: Ctx, hash: string, email: string, rerender: () => void): void {
  const demo = isDemoSession(email);
  guideEnv({
    ctx: c, demo, rerender,
    onDone: (t) => {
      forgetState();
      if (t.mark && c.club && !demo) void guideMark(c.club.id, t.mark).then(() => { forgetState(); if (location.hash === '#/' || location.hash === '') rerender(); }, () => undefined);
      else if (location.hash === '#/' || location.hash === '') rerender();
    },
    onEnd: (t) => demoEndCard(t, email, () => stopTour(true)),
  });
  addScreenHelp(view, c, hash);
  if (demo) demoAfterRender(c, email);
  else document.querySelector('.gd-fab')?.remove();
  // La page est rendue jusqu'au bout, son « ? » posé : une visite peut y montrer un élément (il ne bougera plus).
  pagePainted(view);
  if (!wired) {
    wired = true;
    document.addEventListener('click', (e) => {
      const b = (e.target as HTMLElement).closest<HTMLElement>('[data-tour]');
      if (!b || b.closest('.sheet') || b.closest('.gd-layer')) return;
      e.preventDefault();
      startTour(b.dataset.tour!);
    });
  }
}

export { startTour } from './engine';
export { renderFirstSteps, renderPathCard, renderAllFirstSteps } from './first-steps';
export { emptyGuide } from './empty';
